import * as React from "react";
import { SVGProps, memo } from "react";

const BxBxMinus = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 11H19V13H5V11Z" fill="currentColor" /></svg>;

const Memo = memo(BxBxMinus);
export default Memo;